import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    flex-direction: column; 
`

export const Content = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 32px 12px;
    overflow-y: auto;
`

export const KYCContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`